export default __webpack_public_path__ + "static/threedoorways2-46a5b851093f80624e25d6c770e6fc9f.gif";